
export const calculatePointSize = (total, maxTotal, baseSize = 10, scaleFactor = 6) => {
  const percentage = (total / maxTotal) * 100;
  return baseSize + percentage / scaleFactor;
};